import React from 'react';
import { Outlet } from 'react-router-dom';
import NavBar from './NavBar';
import { Toaster } from 'sonner';

function Layout() {
  return (
    <div className="min-h-screen bg-gradient-civote">
      <NavBar />
      <Outlet />
      <Toaster position="bottom-center" richColors duration={2000} />
    </div>
  );
}

export default Layout;
